import { Popup } from 'vant';
import {
  Component, Vue, Model, Prop,
} from 'vue-property-decorator';


import style from './index.module.scss';

@Component({
  name: 'PopupSlide',
})

export default class PopupSlide extends Vue {
    @Model('change', {
      type: Boolean,
    })
    private popShow!: boolean

    /**
     * 当前popup滑出的方向
    */
    @Prop({
      type: String,
      default: 'bottom',
    }) readonly postion?: string;

    /**
     * 当前popup的标题名称
    */
    @Prop({
      type: String,
      default: '',
    }) readonly popTitle?: string;

    /**
     * 当前popup的标题位置
    */
    @Prop({
      type: String,
      default: 'center',
    }) readonly popPostion?: string;

    /**
     * 当前popup的标题位置
    */
    @Prop({
      type: String,
      default: 'left',
    }) readonly titlePostion!: string;

    /**
     * 当前popup的确认按钮名称
    */
    @Prop({
      type: String,
      default: '',
    }) readonly confirmText?: string;

    /**
     * 是否展示关闭按钮
    */
    @Prop({
      type: Boolean,
      default: true,
    }) readonly showClose?: boolean;

    /**
     * 点击遮罩是否可关闭
    */
    @Prop({
      type: Boolean,
      default: true,
    }) readonly closeOnClickOverlay?: boolean;

    // 关闭
    private onClosedPopup() {
      this.$emit('close');
    }

    // 关闭
    private confirm() {
      this.$emit('confirm');
    }


    private render() {
      return (
        <div class={style.popupSlide}>
          <Popup
            class={style.popupRadius}
            v-model={this.popShow}
            position='bottom'
            closeOnClickOverlay={this.closeOnClickOverlay}
            onClick-overlay={this.closeOnClickOverlay ? this.onClosedPopup.bind(this) : undefined}
          >
            <section class={style.mainContent}>
              <div class={style.textContent}>
                {(this.popTitle || this.$slots.title)
                && <div class={[style.title, style[`title${this.titlePostion}`]]}>
                  { !this.$slots.title && <span>{this.popTitle}</span>}
                  { this.$slots.title}
                  {this.showClose
                  && <span class={style.closed} onClick={this.onClosedPopup.bind(this)}></span>}
                </div>}
                <div class={style.contentWrapper}>{this.$slots.popupContent}</div>
               </div>
               {this.confirmText
                && <div class={[style.primaryButton, 'confirmButton']}
                    onClick={this.confirm.bind(this)}>
                   {this.confirmText}
                </div>}
            </section>
          </Popup>
        </div>
      );
    }
}
